/**
 * New Expedient
 * Expedient for Student Account
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */


import ApiClient from "../ApiClient";
import Error from '../model/Error';
import InlineResponse200 from '../model/InlineResponse200';
import InlineResponse2001 from '../model/InlineResponse2001';

/**
* Enrolls service.
* @module api/EnrollsApi
* @version 1.0
*/
export default class EnrollsApi {

    /**
    * Constructs a new EnrollsApi. 
    * @alias module:api/EnrollsApi
    * @class
    * @param {module:ApiClient} [apiClient] Optional API client implementation to use,
    * default to {@link module:ApiClient#instance} if unspecified.
    */
    constructor(apiClient) {
        this.apiClient = apiClient || ApiClient.instance;
    }



    /**
     * Get student enrolls by period
     * Get student enrolls by period
     * @param {Number} studentId Student Id
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link module:model/InlineResponse200} and HTTP response
     */
    enrollControllerGetEnrollsByPeriodWithHttpInfo(studentId) {
      let postBody = null;
      // verify the required parameter 'studentId' is set
      if (studentId === undefined || studentId === null) {
        throw new Error("Missing the required parameter 'studentId' when calling enrollControllerGetEnrollsByPeriod");
      }

      let pathParams = {
        'student_id': studentId
      };
      let queryParams = {
      };
      let headerParams = {
      };
      let formParams = {
      };

      let authNames = ['BearerAuth'];
      let contentTypes = [];
      let accepts = ['application/json'];
      let returnType = InlineResponse200;
      return this.apiClient.callApi(
        '/account/students/{student_id}/enrolls', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null
      );
    }

    /**
     * Get student enrolls by period
     * Get student enrolls by period
     * @param {Number} studentId Student Id
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link module:model/InlineResponse200}
     */
    enrollControllerGetEnrollsByPeriod(studentId) {
      return this.enrollControllerGetEnrollsByPeriodWithHttpInfo(studentId)
        .then(function(response_and_data) {
          return response_and_data.data;
        });
    }


    /**
     * Postpone enroll to next academic section
     * Set enroll status to postponed
     * @param {Number} studentId Student Id
     * @param {Number} enrollId Enroll Id
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link module:model/InlineResponse2001} and HTTP response
     */
    enrollControllerPostponeEnrollWithHttpInfo(studentId, enrollId) {
      let postBody = null;
      // verify the required parameter 'studentId' is set
      if (studentId === undefined || studentId === null) {
        throw new Error("Missing the required parameter 'studentId' when calling enrollControllerPostponeEnroll");
      }
      // verify the required parameter 'enrollId' is set
      if (enrollId === undefined || enrollId === null) {
        throw new Error("Missing the required parameter 'enrollId' when calling enrollControllerPostponeEnroll");
      }

      let pathParams = {
        'student_id': studentId,
        'enroll_id': enrollId
      };
      let queryParams = {
      };
      let headerParams = {
      };
      let formParams = {
      };

      let authNames = ['BearerAuth'];
      let contentTypes = [];
      let accepts = ['application/json'];
      let returnType = InlineResponse2001;
      return this.apiClient.callApi(
        '/account/students/{student_id}/enrolls/{enroll_id}/postpone', 'POST',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null
      );
    }

    /**
     * Postpone enroll to next academic section
     * Set enroll status to postponed
     * @param {Number} studentId Student Id
     * @param {Number} enrollId Enroll Id
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link module:model/InlineResponse2001}
     */
    enrollControllerPostponeEnroll(studentId, enrollId) {
      return this.enrollControllerPostponeEnrollWithHttpInfo(studentId, enrollId)
        .then(function(response_and_data) {
          return response_and_data.data;
        });
    }


    /**
     * Resume postponed enroll
     * Resume postponed enroll
     * @param {Number} studentId Student Id
     * @param {Number} enrollId Enroll Id
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link module:model/InlineResponse2001} and HTTP response
     */
    enrollControllerResumePostponedEnrollWithHttpInfo(studentId, enrollId) {
      let postBody = null;
      // verify the required parameter 'studentId' is set
      if (studentId === undefined || studentId === null) {
        throw new Error("Missing the required parameter 'studentId' when calling enrollControllerResumePostponedEnroll");
      }
      // verify the required parameter 'enrollId' is set
      if (enrollId === undefined || enrollId === null) {
        throw new Error("Missing the required parameter 'enrollId' when calling enrollControllerResumePostponedEnroll");
      }

      let pathParams = {
        'student_id': studentId,
        'enroll_id': enrollId
      };
      let queryParams = {
      };
      let headerParams = {
      };
      let formParams = {
      };

      let authNames = ['BearerAuth'];
      let contentTypes = [];
      let accepts = ['application/json'];
      let returnType = InlineResponse2001;
      return this.apiClient.callApi(
        '/account/students/{student_id}/enrolls/{enroll_id}/resume', 'POST',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null
      );
    }

    /**
     * Resume postponed enroll
     * Resume postponed enroll
     * @param {Number} studentId Student Id
     * @param {Number} enrollId Enroll Id
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link module:model/InlineResponse2001}
     */
    enrollControllerResumePostponedEnroll(studentId, enrollId) {
      return this.enrollControllerResumePostponedEnrollWithHttpInfo(studentId, enrollId)
        .then(function(response_and_data) {
          return response_and_data.data;
        });
    }


}
